import Icon from './icon'

interface LinkCtaProps {
  href?: string
  children: string
  className?: string
}

export default function LinkCta({ href = '#', children, className = '' }: LinkCtaProps) {
  return (
    <a
      href={href}
      className={`inline-flex items-center gap-2 text-primary text-xs font-bold uppercase tracking-widest hover:gap-4 transition-all ${className}`}
    >
      {children} <Icon name="arrow_forward" className="text-sm" />
    </a>
  )
}
